import { Link } from 'react-router-dom';
import { categories, siteConfig } from '@/mocks/data';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-movie-2-fill text-background-50 text-base"></i>
                </div>
                <span className="text-lg font-semibold text-background-50 font-heading">
                  {siteConfig.name}
                </span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed">
                精选全网口碑最佳的看片网站，涵盖高清电影、热门剧集、综艺纪录片，帮你快速找到最适合的看片网站。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4 font-heading">内容分类</h4>
              <ul className="space-y-2.5">
                {categories.map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.id}`}
                      className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4 font-heading">快速链接</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">
                    首页推荐
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">
                    关于我们
                  </Link>
                </li>
                <li>
                  <a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">
                    用户反馈
                  </a>
                </li>
                <li>
                  <a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">
                    网站收录
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4 font-heading">联系我们</h4>
              <ul className="space-y-2.5">
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <i className="ri-mail-line text-base"></i>
                  <span>{siteConfig.contactEmail}</span>
                </li>
                <li className="text-sm text-background-400">
                  我们致力于为用户提供最优质的影视资源导航服务
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-background-500">
              &copy; {currentYear} {siteConfig.name} 版权所有
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors whitespace-nowrap">隐私政策</a>
              <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors whitespace-nowrap">使用条款</a>
              <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors whitespace-nowrap">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}